var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "form-wrap", on: { click: _vm.onEmptyActive } },
    [
      _vm.formList.length == 0
        ? _c("div", { staticClass: "form-empty" }, [
            _vm._v("请从左侧拖拽或点击添加组件")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-form",
        { attrs: { size: _vm.formSettingState.componentSize } },
        [
          _c(
            "draggable",
            {
              staticClass: "draggable-wrap",
              attrs: {
                value: _vm.formList,
                options: {
                  group: { name: "draggable_wrap", put: true },
                  ghostClass: "draggable-status_ghost",
                  handle: ".drag-bar"
                }
              },
              on: {
                input: function(v) {
                  return (_vm.formList = v.filter(function(i) {
                    return i
                  }))
                },
                add: _vm.handleAddFormItem
              }
            },
            _vm._l(_vm.formList, function(el, i) {
              return _c("form-item-template", {
                key: i,
                attrs: { formNode: el, formParent: _vm.formList }
              })
            }),
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e13870ba", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e13870ba","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Form/FormDraggableContainer.vue
// module id = null
// module chunks = 